export default {
  namespaced: true,
  state: {
    alarm: null,
    sleep: null,
    messages: [],
    cart: []
  },
  mutations: {
    alarm(state, data) {
      state.alarm = data
    },
    sleep(state, data) {
      state.sleep = data
    },
    messages(state, data) {
      state.messages = data
    },
    cart(state, data) {
      if (Array.isArray(data)) state.cart = data
      else state.cart.push(data)

      _$.store.setItem("cart", state.cart)
    },
    flush(state) {
      Object.keys(state).forEach(key => {
        if (Array.isArray(state[key])) state[key] = []
        else state[key] = null
      })
    }
  },
  getters: {
    newMessages: state => {
      return state.messages.filter(message => !message.readed)
    },
    cart: state => {
      return state.cart
    }
  },
  actions: {
    fetchCart(context) {
      context.commit("cart", _$.store.getItem("cart") || [])
      return true
    },
    async fetchOrders(context) {
      return __.api.get.orders().then(records => {
        if (!Array.isArray(records) || !records.length) return true

        for (const record of records) {
          if (record.action === "Vod") {
            const model = context.rootState.data.vods?.find(item => item.id == record.description)
            if (!model) continue
            model.owned = true
          } else if (record.action === "Channel") {
            for (const channel of context.rootGetters["live/allChannels"]) {
              if (channel.price?.group == record.description) channel.owned = true
            }
          }
        }
        return true
      })
    }
  }
}
